import { range } from "lodash";
import { ALLOCATION_COLUMNS } from "../../utils/columns";

export const groupItemsBy = (items, groupFields) => {
    return items.reduce((groupedItems, item) => {
        if (item.path.length === 3) {
            const newPath = []
            groupFields.forEach((field) => { newPath.push(item[field]) })
            newPath.push(item.path[2])
            return [...groupedItems, { ...item, path: newPath }]
        }
        return groupedItems;
    }, [])
}

const sum = (amount) => {
    return amount
}

const avg = (amount, count) => {
    return amount / count
}

const GROUP_AGGREGATIONS = {
    [ALLOCATION_COLUMNS["Warehouse OH - Units"].field]: sum,
    [ALLOCATION_COLUMNS["In Transit - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Store OH - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Target Store OH - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Store Need - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Suggested Allocation - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Shortfall - Units"].field]: sum,
    [ALLOCATION_COLUMNS["Avg Weekly Sales - Units"].field]: sum,
    [ALLOCATION_COLUMNS["% Committed"].field]: sum,
    [ALLOCATION_COLUMNS["Gross Margin $"].field]: sum,
    [ALLOCATION_COLUMNS["COGS"].field]: sum,
    [ALLOCATION_COLUMNS["Retail $"].field]: sum,
    [ALLOCATION_COLUMNS["Warehouse OOS"].field]: sum,
    [ALLOCATION_COLUMNS["Store OOS"].field]: sum,
}

export const getAggregatedGroupedRows = (items, productLevel) => {
    const SPLITTING_SIGN = "/"
    const levels = {};
    items.forEach(item => {
        range(0, productLevel).forEach((index) => {
            const path = item.path.slice(0, index + 1).join(SPLITTING_SIGN);
            if (!levels[path]) {
                levels[path] = []
            }
            levels[path] = [...levels[path], item];
        })
    })

    const rows = [];
    let uid = -1000;

    Object.entries(levels).forEach(([levelPath, children]) => {
        const path = levelPath.split(SPLITTING_SIGN);
        const row = {
            path,
            uid: uid++
        };

        // Set all aggregations fields to 0
        const aggregation = Object.keys(GROUP_AGGREGATIONS)
            .reduce((aggObj, field) =>
                Object.assign(aggObj, { [field]: 0 }), {})

        children.forEach(child => {
            Object.keys(aggregation).forEach(field => {
                aggregation[field] +=
                    Number.isFinite(+child[field]) ? +child[field] : 0
            })
        })

        Object.keys(aggregation).forEach(field => {
            aggregation[field] = GROUP_AGGREGATIONS[field](aggregation[field], children.length)
            row[field] = aggregation[field]
        })

        rows.push(row)
    })

    return rows;
}
